export enum GenericExpandablePropertyType {
  DOCUMENTS = 'Documents'
}

export enum VehicleExpandablePropertyType {
  ASSIGNED_EMPLOYEE = 'AssignedEmployee',
  ODOMETER_READING = 'OdometerReading',
  DIMENSION_SPECIFICATIONS = 'DimensionSpecifications',
  FUEL_ECONOMY_SPECIFICATIONS = 'FuelEconomySpecifications',
  ENGINE_SPECIFICATIONS = 'EngineSpecifications',
  WHEELS_AND_TIRES_SPECIFICATIONS = 'WheelsAndTiresSpecifications',
  DOCUMENTS = 'Documents'
}

export enum MachineExpandablePropertyType {
  ASSIGNED_EMPLOYEE = 'AssignedEmployee',
  ODOMETER_READING = 'OdometerReading',
  DIMENSION_SPECIFICATIONS = 'DimensionSpecifications',
  FUEL_ECONOMY_SPECIFICATIONS = 'FuelEconomySpecifications',
  ENGINE_SPECIFICATIONS = 'EngineSpecifications',
  WHEELS_AND_TIRES_SPECIFICATIONS = 'WheelsAndTiresSpecifications',
  DOCUMENTS = 'Documents'
}

export enum JobExpandablePropertyType {
  SCHEDULE = 'Schedule',
  ASSIGNED_EMPLOYEES = 'AssignedEmployees',
  ASSIGNED_EMPLOYEES_EMPLOYEE = 'AssignedEmployees.Employee',
  WORK_ORDER_VENDOR = 'WorkOrderVendor',
  ISSUE_REPORTER = 'IssueReporter',
  ASSET = 'Asset',
  ASSET_INFO = 'AssetInfo',
  ASSET_VEHICLE = 'Asset.Vehicle',
  ASSET_EQUIPMENT = 'Asset.Equipment',
  ASSET_MACHINE = 'Asset.Machine',
  MAINTENANCE_TYPES = 'MaintenanceTypes',
  MAINTENANCE_ISSUES = 'MaintenanceIssues',
  MAINTENANCE_ISSUES_ISSUE = 'MaintenanceIssues.Issue',
  MAINTENANCE_PARTS = 'MaintenanceParts',
  TASK_SHEETS = 'TaskSheets',
  TASK_SHEETS_HEADER = 'TaskSheets.Header',
  TASK_SHEETS_BODIES = 'TaskSheets.Bodies',
  TASK_SHEETS_FOOTER = 'TaskSheets.Footer',
  DOCUMENTS = 'Documents',
  NEXT_TRIGGER_INFO = 'NextTriggerInfo'
}

export enum JobScheduleExpandablePropertyType {
  ASSETS = 'Asset',
  ASSET_INFO = 'AssetInfo',
  MAINTENANCE_TYPES = 'MaintenanceTypes',
  ASSETS_VEHICLE = 'Asset.Vehicle',
  ASSETS_EQUIPMENT = 'Asset.Equipment',
  ASSETS_MACHINE = 'Asset.Machine',
  ASSIGNED_EMPLOYEES = 'AssignedEmployees',
  ASSIGNED_EMPLOYEES_EMPLOYEE = 'AssignedEmployees.Employee',
  WORK_ORDER_VENDOR = 'WorkOrderVendor',
  TASK_SHEETS = 'TaskSheets',
  DOCUMENTS = 'Documents',
  NEXT_TRIGGER_INFO = 'NextTriggerInfo'
}

export enum JobActivitiesExpandablePropertyType {
  JOB = 'Job',
  USER = 'User'
}

export enum EmployeeExpandablePropertyType {
  ADDRESS = 'Address',
  NEXT_OF_KIN = 'NextOfKinDetail'
}
